import { render, staticRenderFns } from "./MobileHomeTwoNews.vue?vue&type=template&id=6311d7f5&scoped=true&"
import script from "./MobileHomeTwoNews.vue?vue&type=script&lang=ts&"
export * from "./MobileHomeTwoNews.vue?vue&type=script&lang=ts&"
import style0 from "./MobileHomeTwoNews.vue?vue&type=style&index=0&id=6311d7f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6311d7f5",
  null
  
)

export default component.exports